import { useMemo } from 'react';
import { clsx } from 'clsx';
import { useIntent } from '@/hooks/use-intent';
import { useFeedback } from './hooks/use-feedback';
import { FeedbackControlProps } from './types';
import { FeedbackThumbs } from './feedback-thumbs';

export type FeedbackProps = React.ComponentProps<'div'> & {
  object: string;
  slots?: {
    Control?: React.ElementType<FeedbackControlProps>;
  };
  metadata?: Record<string, unknown>;
};

export function Feedback({
  className,
  object,
  slots = {},
  metadata,
  ...others
}: FeedbackProps) {
  const { Control = FeedbackThumbs } = slots;
  const [{ data: feedback }, rate] = useFeedback({ object, metadata });

  const controlValue = useMemo(() => {
    return !feedback
      ? undefined
      : { rating: feedback.rating, comment: feedback.comment };
  }, [feedback]);

  const [handleValueChange] = useIntent(
    (data: { rating: number; comment?: string }) => {
      rate(data.rating, data.comment);
    },
    { resetTimeout: true }
  );

  return (
    <div {...others} className={clsx('MemoFeedback-root', className)}>
      <Control
        className="MemoFeedback-display"
        onValueChange={handleValueChange}
        value={controlValue}
      />
    </div>
  );
}

Feedback.displayName = 'Feedback';
